import axios from "axios";
import { proxyUrl } from "../config";
import { setupInterceptorsTo } from "./Interceptors";
import { FundDocumentType } from "./FundService";
setupInterceptorsTo(axios);

export interface PortfolioModelFundsDocumentsType
{
    isin: string,
    name: string,
    documents: FundDocumentType[]
}

class PortfolioModelService
{
    public getPortfolioModelDocuments = async (portfolioModelId: number): Promise<PortfolioModelFundsDocumentsType[]> =>
    {
        let url: string = `${proxyUrl}/portfolioModels/${portfolioModelId}/documents`
        const req = await axios.get<any>(url)
        return req.data
    }
}

const portfolioModels = new PortfolioModelService();
export default portfolioModels;